import Image from 'next/image'
import { Box, Grid } from '@mui/material'

const Block1 = () => {
  return (
    <Grid container lg={12} className='mt-40 mb-20 items-center'>
      <Grid item xs={12} md={8} lg={8} container>
        <div className='mt-5'>
          <div className='grid-container' style={{ display: 'flex' }}>
            <div
              className='text-left col-md-8 gap-2'
              style={{ marginTop: '100px' }}
            >
              <div className='grid-cards'>
                <div className='investor-text'>
                  <h3>COMPANY</h3>
                  <p>
                    Royal Smart Limousine is a member of the Rashed Al Jabri
                    Group of Companies. We have been shaping seamless travel
                    experiences since 2002 with our luxury limousine services,
                    Royal Smart Limousine. Now, we have launched our RSL Super
                    App that offers a one-stop solution for all your travel
                    needs, from flights, and limousine services to exciting tour
                    packages, bus transportation and so much more. We are
                    committed to exceeding your expectations, providing
                    exceptional service, and crafting priceless memories. Let us
                    work with you to plan an unforgettable journey, inviting you
                    to experience The Smart Experience in the heart of Dubai
                    visionary, optimistic, and world-class development.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Grid>

      <Grid item xs={12} md={4} lg={4}>
        <div className='image-container col-md-3' style={{ width: '100%' }}>
          <img
            src={`${process.env.IMAGE_BASE_URL}/images/about/about1.png`}
            alt='Investor Image'
            className='investor_Img'
            style={{
              marginBottom: '12px'
            }}
          />
          <h5
            style={{
              textAlign: 'center',
              maxWidth: '300px',
              width: '300px',
              margin: 'auto'
            }}
          >
            RASHED MATAR RASHED ALJABRI
            <br />
            <span style={{
              fontSize: '14px'
            }}>Chairman</span>
          </h5>
        </div>
      </Grid>
    </Grid>
  )
}

export default Block1
